import React from 'react';

import { PageSection } from 'components';
import { useTranslation } from 'react-i18next';
import {
    Disclaimer,
    DisclaimerDescription,
    DisclaimerItem,
    DisclaimerSubtitle,
    DisclaimerTitle,
} from './styled';

const sectionConfig = {
    CWrap: {
        css: {
            marginBottom: 120,

            '@media(max-width: 1279px)': {
                marginBottom: 65,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
            zIndex: 10,

            '@media(max-width: 1023px)': {
                paddingTop: '0 !important',
            },
        },
    },
};

export const Stats = () => {
    const { t } = useTranslation('pages/academy-alliance');

    return (
        <PageSection config={sectionConfig}>
            <Disclaimer>
                <DisclaimerItem>
                    <DisclaimerTitle>{t('stats-title-1')}</DisclaimerTitle>
                    <DisclaimerSubtitle>
                        {t('stats-subtitle-1')}

                        <DisclaimerDescription>
                            {t('stats-description-1')}
                        </DisclaimerDescription>
                    </DisclaimerSubtitle>
                </DisclaimerItem>
                <DisclaimerItem>
                    <DisclaimerTitle>{t('stats-title-2')}</DisclaimerTitle>
                    <DisclaimerSubtitle>
                        {t('stats-subtitle-2')}

                        <DisclaimerDescription>
                            {t('stats-description-2')}
                        </DisclaimerDescription>
                    </DisclaimerSubtitle>
                </DisclaimerItem>
                <DisclaimerItem>
                    <DisclaimerTitle>{t('stats-title-3')}</DisclaimerTitle>
                    <DisclaimerSubtitle>
                        {t('stats-subtitle-3')}

                        <DisclaimerDescription>
                            {t('stats-description-3')}
                        </DisclaimerDescription>
                    </DisclaimerSubtitle>
                </DisclaimerItem>
            </Disclaimer>
        </PageSection>
    );
};
